module.exports = __webpack_public_path__ + "img/programs-bg.79af9927.jpg";